import React from 'react';

export const DevsuWhiteIcon = () => {
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M17.7233 0H3.9019C1.74689 0 0 1.32595 0 2.96249C0 4.59903 1.74689 5.92498 3.9019 5.92498H17.7233C19.8783 5.92498 21.6252 4.59903 21.6252 2.96249C21.6252 1.32595 19.8783 0 17.7233 0Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M17.7233 17.7736H3.9019C1.74689 17.7736 0 19.0995 0 20.7361C0 22.3726 1.74689 23.6985 3.9019 23.6985H17.7233C19.8783 23.6985 21.6252 22.3726 21.6252 20.7361C21.6252 19.0995 19.8783 17.7736 17.7233 17.7736Z"
          fill="white"
        />
        <path
          id="Vector_3"
          d="M3.82847 14.8111C5.94288 14.8111 7.65694 13.4847 7.65694 11.8486C7.65694 10.2125 5.94288 8.88611 3.82847 8.88611C1.71406 8.88611 0 10.2125 0 11.8486C0 13.4847 1.71406 14.8111 3.82847 14.8111Z"
          fill="white"
        />
        <path
          id="Vector_4"
          d="M25.0317 8.88611H15.1087C12.9947 8.88611 11.2803 10.2121 11.2803 11.8486C11.2803 13.4851 12.9947 14.8111 15.1087 14.8111H25.0317C27.1457 14.8111 28.8602 13.4851 28.8602 11.8486C28.8602 10.2121 27.1457 8.88611 25.0317 8.88611Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
